let oneCmsUrl = {
  supportedLocale: '',
};
/* istanbul ignore next */
export default function getOneCmsUrl(location) {
  if (location.indexOf('http://localhost:3000') >= 0) {
    oneCmsUrl = {
      supportedLocale: 'https://inter-pdgemapp.aexp.com/travelers-cheques/TCLocator/supportedlocale/supportedlocale.json',
    };
  }
  if (location.indexOf('https://travelers-cheques-dev.americanexpress.com') >= 0) {
    oneCmsUrl = {
      supportedLocale: 'https://inter-pdgemapp.aexp.com/travelers-cheques/TCLocator/supportedlocale/supportedlocale.json',
    };
  }
  if (location.indexOf('https://travelers-cheques-qa.americanexpress.com') >= 0 || location.indexOf('https://qwww.americanexpress.com') >= 0) {
    oneCmsUrl = {
      supportedLocale: 'https://qicm.aexp-static.com/travelers-cheques/TCLocator/supportedlocale/supportedlocale.json',
    };
  }
  if (location.indexOf('https://travelers-cheques.americanexpress.com') >= 0 || location.indexOf('https://www.americanexpress.com') >= 0) {
    oneCmsUrl = {
      supportedLocale: 'https://icm.aexp-static.com/travelers-cheques/TCLocator/supportedlocale/supportedlocale.json',
    };
  }
  return oneCmsUrl.supportedLocale;
}
